// extracted by mini-css-extract-plugin
export default {"descriptionContainer":"productDevelopment_descriptionContainer__iLlFR","descriptionSubContainer":"productDevelopment_descriptionSubContainer__CHDGw"};